import appLogger from "../../utils/app-logger";
import UserServiceApi from "../../services/user-service-api";
import AuthServiceApi from "../../services/auth-service-api";
import EventServiceApi from "../../services/event-service-api";
import ABTestServiceApi from "../../services/abtest-service-api";
import EventService from "../../services/event-service-api";
import {
  createCookie,
  readCookie,
  getZipCityStateBasedOnIP,
  currentPortalCD,
  PerquisiteBountyEnable,
  isAllAddressCookiePresent,
  getIPConfig,
  generateUinqueIDentifier,
  deleteCookie,
} from "../../utils/helpers";
import SingleSignOnApi from "../../services/single-sign-on-api";
import DocBuilderService from "../../services/doc-builder-api";
import { userStore } from "../../utils/signals";
import userServiceApi from "../../services/user-service-api";
import { currentDomain, getTenantGroupId, getTenantId } from "../../utils/general-config";
import { trackEventsV2 } from "../../utils/tracking-events";
import { signInUser } from "../sign-in/actions";
import setLegacyCookie from "../../utils/ssohandler";
import ssoHandler from "../../utils/ssohandler";
import ABTestService from "../../services/abtest-service-api";
import { toast } from "react-toastify";
import { DomainEnum } from "../../services/enum/environment-enum";
import { EMPTY_GUID } from "../../utils/constants";
import docEditorServiceApi from "../../services/doc-editor-service-api";

const signUpUser = async (data) => {
  const queryParams = new URLSearchParams(window.location.search);
  const emailIdCookie = readCookie("seml");
  const signsimplipwd = readCookie("pwd");
  const signsimpliuid = readCookie("uid");
  let isExistingUser = false;
  if (!!signsimpliuid) {
    if (!!emailIdCookie) {
      if (decodeURIComponent(emailIdCookie) === data.email) {
        let userGuid = signsimpliuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
        let userResponse = await userServiceApi.getUser(userGuid);
        let userProfileResponse = await userServiceApi.getUserProfileByServiceToken(userGuid);
        if (
          !!userResponse.parentUserGuid ||
          userResponse.isPremiumUser === true ||
          userProfileResponse.hasViewedSellPage === true ||
          userResponse.portalCD?.toUpperCase() === "WSRB"
        ) {
          isExistingUser = true;
        }
      }
    }
  }

  if (
    !isExistingUser &&
    queryParams.has("evp") &&
    !!emailIdCookie &&
    !!signsimplipwd &&
    decodeURIComponent(emailIdCookie) === data.email
  ) {
    const changePasswordData = {
      userGuid: signsimpliuid,
      newPassword: data.password,
      currentpassword: signsimplipwd,
    };
    await UserServiceApi.updatePassword(changePasswordData);
    const signinDataParams = {
      username: data.email.trim(),
      password: data.password.trim(),
      tenantGroupId: getTenantGroupId(),
      parentId: queryParams.get("pgid"),
      invitationToken: queryParams.get("gusr"),
    };
    var signinResponse = await signInUser(signinDataParams);
    let isValid = !signinResponse.isAccountLocked;
    return { userGuid: signinResponse.validUserGuid, isValid: isValid };
  } else {
    return UserServiceApi.createUser(data)
      .then((response) => {
        if (response.isValid) {
          appLogger.log("inside signUpUser1 ");
          createCookie("userguid", response.userGuid, 1);
          return response;
        } else {
          return response;
          //dispatch(savePersonalInfoFailure(response.data));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const signUpAsExternalUser = (data) => {
  const {
    createUser: { email },
  } = data;
  if (!!email) {
    return UserServiceApi.createExternalUser(data)
      .then((response) => {
        if (!!response) {
          createCookie("userguid", response.userGuid, 1);
          console.log("inside signUpAsExternalUser ");
          return response;
        }
      })
      .catch((error) => {
        if (error.isAxiosError) {
          let errorMsg = `${error.toString()} `;
          if (error.response?.data?.isAccountLocked) {
            console.log("Your account is locked. Please connect to customer support");
            toast.error(errorMsg);
          } else {
            toast.error(errorMsg);
          }
          throw error;
        }
      });
    // .catch((error) => dispatch(savePersonalInfoFailure(error)));
  }
};

const authUser = (authData, domain) => {
  return AuthServiceApi.AuthenticateUser(authData).then(async (authResponse) => {
    const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = authResponse;
    localStorage.setItem("jwtToken", jwtToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("expiresAt", expiresAt);
    createCookie("jwtToken", jwtToken, 1, domain);
    createCookie("refreshToken", refreshToken, 1, domain);
    createCookie("pdfsimplirefreshToken", refreshToken, 10, domain);
    if (currentDomain() !== DomainEnum.WORKSIMPLI) {
      createCookie("pdfsimpliauth", JSON.stringify(authResponse), 10, domain);
    }
    createCookie("expiresAt", expiresAt, 1, domain);
    createCookie("ssoauth", "1", 1, domain);
    createCookie("legacyTicket", legacyToken, 1, domain);
    // await ssoHandler();
    return authResponse;
    //save the user address from ip-pro
  });
};
const getAddress = async (userGuid) => {
  var ipAddress = readCookie("ipAddress");
  return await getZipCityStateBasedOnIP(ipAddress)
    .then((resp) => {
      return resp;
    })
    .catch(() => {
      return null;
    });
};

const SignupSuccessEvent = (userGuid, email, locale) => {
  return trackEventsV2("signUpSuccess", {
    visitId: readCookie("visitGuid"),
    userGuid: userGuid,
    portalSource: currentPortalCD(locale),
    eventLabel: "signUp Success",
    email: email,
    firstName: "",
    lastName: "",
  });
};

const saveUserAddress = (data) => {
  return userServiceApi
    .saveUserAddress(data)
    .then((res) => {
      return res;
    })
    .catch(() => {
      return null;
    });
};

const signUpExternalUser = (data) => {
  const {
    createUser: { email },
  } = data;
  if (!!email) {
    return UserServiceApi.createExternalUser(data)
      .then((response) => {
        if (!!response) {
          createCookie("userguid", response.userGuid, 1);
          appLogger.log("inside createExternalUser ");
          const authData = {
            Username: email.trim(),
            UserGuid: response.userGuid,
            Email: email.trim(),
          };
          return AuthServiceApi.AuthenticateUser(authData).then((authResponse) => {
            const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("pdfsimplirefreshToken", refreshToken, 10);
            if (currentDomain() !== DomainEnum.WORKSIMPLI) {
              createCookie("pdfsimpliauth", JSON.stringify(authResponse), 10);
            }
            createCookie("expiresAt", expiresAt, 1);
            createCookie("legacyTicket", legacyToken, 1);
            return response;
          });
        }
      })
      .catch((error) => console.log("Error"));
    // .catch((error) => dispatch(savePersonalInfoFailure(error)));
  }
};

const eventServicePost = (data) => {
  return EventServiceApi.postEventData(data)
    .then((response) => {
      return true;
    })
    .catch((error) => {
      console.log("Error");
      return false;
    });
  // .catch((error) => dispatch(savePersonalInfoFailure(error)));
};

const getUserDocs = (userguid) => {
  return DocBuilderService.findByUserGuid(userguid)
    .then((response) => {
      return response;
    })
    .catch((error) => console.log(error));
};

const loginAttempt = (data) => {
  return UserServiceApi.loginAttempt(data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Error");
    });
};

const postDataToEventService = (data, eventType, eventSubType, topicName) => {
  return EventServiceApi.postDataToEventService(data, eventType, eventSubType, topicName)
    .then((response) => {
      return true;
    })
    .catch((error) => {
      console.log("Error");
      return false;
    });
};
const getUserAbridged = () => {
  return UserServiceApi.getUserObject();
};
const postDataToEventServiceSchedule = (data, eventType, eventSubType, topicName, scheduleTime) => {
  return EventServiceApi.postDataToEventServiceScheduledTime(data, eventType, eventSubType, topicName, scheduleTime)
    .then((response) => {
      return true;
    })
    .catch((error) => {
      console.log("Error");
      return false;
    });
};
const getUserObject = () => {
  return UserServiceApi.getUserObject()
    .then((response) => {
      if (!!response) {
        let userGuid = response.userGuid;
        let email = response.email;
        var validUserGuid = userGuid;
        if (userGuid.includes("-") == false) {
          validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
        }
        let parentUserGuid = response.parentUserGuid;
        //dispatch(PushDataToUserInfo(validUserGuid, email, parentUserGuid));
        userStore.value.email.value = response.email;
        userStore.value.isPerquisiteBountyEnable.value = PerquisiteBountyEnable(
          response.perquisiteBountyKey,
          response.userGuid
        );
        userStore.value.portalCD.value = response.portalCD;
        userStore.value.userGuid.value = response.userGuid;
        return validUserGuid;
      }
      return response;
    })
    .catch((error) => {});
};

const SwitchVisitorUserAbTest = (switchData) => {
  //pass this data format request from component
  if (
    Array.isArray(switchData?.AbTestIds) &&
    switchData.AbTestIds.length > 0 &&
    switchData?.UserId &&
    switchData.UserId !== EMPTY_GUID &&
    switchData?.VisitorId &&
    switchData.VisitorId !== EMPTY_GUID
  ) {
    const data = {
      AbTestIds: switchData.AbTestIds,
      UserGuid: switchData.UserId,
      VisitorID: switchData.VisitorId,
      PortalCD: switchData.portalCD,
    };
    return EventService.postEventDataV2("user","user_visitor_mapping",switchData.UserId,"abtest_mapping",data);
    // return ABTestServiceApi.SwitchVisitorUser(data).then((response) => {});
  }
};

const VisitorConduct = async ({ abTestId, visitorID, portalCD }) => {
  try {
    if (abTestId && abTestId != EMPTY_GUID && visitorID && visitorID != EMPTY_GUID) {
      return await ABTestServiceApi.VisitorConduct({
        abTestId,
        visitorID,
        portalCD,
      });
    }
  } catch (error) {
    console.log("Error");
  }
};

const ensureVisitorGuid = async (maxAttempts = 10, delayMs = 300) => {
  let attempt = 0;
  const promise = new Promise((resolve, reject) => {
    const intervalId = setInterval(() => {
      const visitorGuid = readCookie("visitorGuid");
      if (visitorGuid) {
        clearInterval(intervalId);
        resolve(visitorGuid);
      }
      if (attempt >= maxAttempts) {
        clearInterval(intervalId);
        resolve(Promise.reject("Missing visitorGuid after retries"));
      }
      if (attempt >= maxAttempts) {
        clearInterval(intervalId);
        reject("Missing visitorGuid after retries");
      }
      attempt++;
    }, delayMs);
  });
  return promise;
};

const VerifyCaptcha = async (recaptchaScoreRequest, domain) => {
  try {
    const captchaResponse = await userServiceApi.VerifyCaptcha(recaptchaScoreRequest, domain);
    return captchaResponse;
  } catch (error) {
    console.log("Error in verifying captcha", error);
    return null;
  }
};

const TrackEvent = async (userguid, type, email) => {
  try {
    const visitorId = readCookie("visitorGuid");
    const visitId = readCookie("visitGuid");
    const data = {
      ActorId: !!userguid ? userguid : EMPTY_GUID,
      EventPublishedOn: new Date().toISOString(),
      EventType: "auditlog",
      EventSubType: type,
      EventData: {
        category: "Signup",
        subcategory: type,
        payloadname: "AuditData",
        data: {
          Id: generateUinqueIDentifier(),
          UserGuid: userguid,
          VisitorId: visitorId,
          VisitId: visitId,
          UserAction: currentDomain(),
          Email: email,
        },
      },
    };
    await docEditorServiceApi.TrackEvent(data);
  } catch (error) {
    console.log("Error in Sending event", error);
  }
};

const updateUserGuid = async (docid, userGuid) => {
  try {
    const response = await DocBuilderService.updateUserGuid(docid, userGuid);
    if (response) {
      return response;
    }
  } catch (error) {
    console.log("Error in updationg userGuid", error);
    return null;
  }
};

const DeleteTemplateDocId = async (docid, isInitialStep = false) => {
  const getDocId = await getDocIds();
  let storeValue = {};

  if (isInitialStep === true) {
    deleteCookie("docid");
  }

  if (getDocId) {
    for (const key in getDocId) {
      if (getDocId[key] === docid) {
        delete getDocId[key];
      }
    }
    storeValue = getDocId;
  }

  localStorage.setItem("saveDocIds", JSON.stringify(storeValue));
};

const getDocIds = async () => {
  const getDocIds = localStorage.getItem("saveDocIds");
  let toParse = null;
  if (getDocIds) {
    toParse = JSON.parse(getDocIds);
  }
  const storeValue = toParse;
  return storeValue;
};

const UserGuidABTestConduct = async (data) => {
  try {
    if (data.AbTestId && data.AbTestId != EMPTY_GUID && data.userGuid && data.userGuid != EMPTY_GUID) {
      return await ABTestServiceApi.UserConduct(data);
    }
  } catch (error) {
    console.log("Error");
  }
  return null;
};
const GetEditorQueryInfo = async (id) => {
  try {
    const response = await docEditorServiceApi.GetEditorQueryInfo(id);
    return response;
  } catch (error) {
    console.log("Error in fetching Editor Query Info", error);
    return null;
  }
};

export {
  signUpUser,
  signUpExternalUser,
  eventServicePost,
  loginAttempt,
  getUserDocs,
  postDataToEventService,
  postDataToEventServiceSchedule,
  getUserObject,
  authUser,
  getAddress,
  saveUserAddress,
  signUpAsExternalUser,
  SignupSuccessEvent,
  getUserAbridged,
  SwitchVisitorUserAbTest,
  VisitorConduct,
  ensureVisitorGuid,
  VerifyCaptcha,
  TrackEvent,
  updateUserGuid,
  DeleteTemplateDocId,
  getDocIds,
  UserGuidABTestConduct,
  GetEditorQueryInfo,
};
